export default "__VITE_ASSET__CPrUjCxP__"